<template>
  <v-dialog :value="value" width="500" persistent>
    <v-card>
      <div class="text-xs-right">
        <v-btn flat fab small @click="$emit('input', false)">
          <v-icon>close</v-icon>
        </v-btn>
      </div>

      <v-card-text>
        <template v-if="selectedBot.theme == 'universalutilities'">
          <div class="caption">{{ $t('ประปา') }}</div>
          <div v-if="selectedBot.uu_areaname" class="primary--text">
            {{ selectedBot.uu_areaname }}
          </div>
          <template v-else>
            <v-select
              v-model="input.uuAreaName"
              :items="areaname"
              label="ประปา"
              placeholder="ประปา"
              solo
            ></v-select>
          </template>
          <v-layout wrap>
            <v-flex sm6 style="padding-right: 1em">
              <div class="form-control">
                <label>ชื่อ</label>
                <input v-model="input.uu_name" type="text" />
              </div>
            </v-flex>
            <v-flex sm6 style="padding-right: 1em">
              <div class="form-control">
                <label>เบอร์โทร</label>
                <input v-model="input.phoneno" type="number" />
              </div>
            </v-flex>
            <v-flex sm6 style="padding-right: 1em">
              <div class="form-control">
                <label>LineID</label>
                <input v-model="input.search" type="text" />
              </div>
            </v-flex>
            <v-flex sm6>
              <label>{{ $t('Register Status') }}</label>
              <multiselect
                v-model="input.uu_register_status"
                :options="['ลงทะเบียน', 'ไม่ลงทะเบียน']"
                select-label
                selected-label
                deselect-label
                :placeholder="$t('Register Status')"
              ></multiselect>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <div class="form-control">
                <label>Last Conversation From</label>
                <v-layout wrap>
                  <v-flex
                    xs6
                    class="form-control"
                    :class="{ 'has-error': errors.has('startdate') }"
                  >
                    <v-menu
                      ref="openStartDate"
                      v-model="openStartDate"
                      :close-on-content-click="false"
                      full-width
                      max-width="290px"
                      color="primary"
                    >
                      <template #activator="{ on }">
                        <input
                          v-model="input.lastconversationfromdate"
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Date')"
                          readonly
                          clearable
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="input.lastconversationfromdate"
                        color="primary"
                        @input="openStartDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs4 class="pl-1">
                    <v-menu
                      ref="openStartTime"
                      v-model="openStartTime"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="input.lastconversationfromtime"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      :disabled="input.lastconversationfromdate == null"
                      max-width="290px"
                      min-width="290px"
                    >
                      <template #activator="{ on }">
                        <input
                          v-model="input.lastconversationfromtime"
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Time')"
                          readonly
                          :disabled="input.lastconversationfromdate == null"
                          v-on="on"
                        />
                      </template>
                      <v-time-picker
                        v-if="openStartTime"
                        v-model="input.lastconversationfromtime"
                        full-width
                        @click:minute="$refs.openStartTime.save(input.lastconversationfromtime)"
                      ></v-time-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs2>
                    <v-btn
                      fab
                      flat
                      small
                      color="primary"
                      style="height: 35px; width: 35px"
                      @click="
                        input.lastconversationfromdate = null
                        input.lastconversationfromtime = null
                      "
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
            <v-flex>
              <div class="form-control">
                <label>Last Conversation To</label>
                <v-layout wrap>
                  <v-flex
                    xs6
                    class="form-control"
                    :class="{ 'has-error': errors.has('startdate') }"
                  >
                    <v-menu
                      ref="openEndDate"
                      v-model="openEndDate"
                      :close-on-content-click="false"
                      full-width
                      max-width="290px"
                      color="primary"
                    >
                      <template #activator="{ on }">
                        <input
                          v-model="input.lastconversationtodate"
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Date')"
                          readonly
                          clearable
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="input.lastconversationtodate"
                        color="primary"
                        @input="openEndDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs4 class="pl-1">
                    <v-menu
                      ref="openEndTime"
                      v-model="openEndTime"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="input.lastconversationtotime"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                      :disabled="input.lastconversationtodate == null"
                    >
                      <template #activator="{ on }">
                        <input
                          v-model="input.lastconversationtotime"
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Time')"
                          readonly
                          :disabled="input.lastconversationtodate == null"
                          v-on="on"
                        />
                      </template>
                      <v-time-picker
                        v-if="openEndTime"
                        v-model="input.lastconversationtotime"
                        full-width
                        @click:minute="$refs.openEndTime.save(input.lastconversationtotime)"
                      ></v-time-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs2>
                    <v-btn
                      fab
                      flat
                      small
                      color="primary"
                      style="height: 35px; width: 35px"
                      @click="
                        input.lastconversationtodate = null
                        input.lastconversationtotime = null
                      "
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </template>
        <template v-if="selectedBot.theme != 'universalutilities'">
          <div class="caption">{{ $t('Search') }}</div>
          <div class="form-control">
            <input v-model="input.search" type="text" :placeholder="$t('Search')" />
          </div>

          <div class="caption">{{ $t('Note') }}</div>
          <div class="form-control">
            <input v-model="input.temp_msg" type="text" :placeholder="$t('Note')" />
          </div>

          <div class="caption">{{ $t('Address') }}</div>
          <div class="form-control">
            <input v-model="input.address" type="text" :placeholder="$t('Address')" />
          </div>

          <div class="caption">{{ $t('email') }}</div>
          <div class="form-control">
            <input v-model="input.email" type="text" :placeholder="$t('email')" />
          </div>

          <div class="caption">{{ $t('phone no.') }}</div>
          <div class="form-control">
            <input v-model="input.phoneno" type="text" :placeholder="$t('phone no.')" />
          </div>

          <template v-if="selectedBot.theme == 'ustore'">
            <div class="caption">{{ $t('ชื่อ นามสกุล') }}</div>
            <div class="form-control">
              <input v-model="input.customrealname" type="text" :placeholder="$t('ชื่อ นามสกุล')" />
            </div>

            <div class="caption">{{ $t('Email') }}</div>
            <div class="form-control">
              <input v-model="input.email" type="text" :placeholder="$t('Email')" />
            </div>
          </template>

          <template v-if="selectedBot.type === 'tigerpoly'">
            <div class="caption">Emp. ID</div>
            <div class="form-control">
              <input v-model="input.employee_id" type="text" placeholder="Emp. ID" />
            </div>

            <div class="caption">{{ $t('position') }}</div>
            <div class="form-control">
              <input v-model="input.position" type="text" :placeholder="$t('position')" />
            </div>

            <div class="caption">{{ $t('Department') }}</div>
            <div class="form-control">
              <input v-model="input.department" type="text" :placeholder="$t('Department')" />
            </div>
          </template>

          <div class="caption">{{ $t('Status') }}</div>
          <div class="form-control mb-2">
            <multiselect
              v-model="input.status"
              :options="statusOptions"
              :placeholder="$t('Status')"
              :taggable="true"
              @tag="addStatus"
            >
            </multiselect>
            <!-- <input type="text" v-model="input.status" :placeholder="$t('Status')" /> -->
          </div>
          <div class="caption">{{ $t('Tags') }}</div>
          <div class="form-control mb-2">
            <multiselect
              v-model="input.tags"
              :options="tagOptions"
              :placeholder="$t('Tags')"
              :multiple="true"
              :taggable="true"
              @tag="addTag"
            >
            </multiselect>
          </div>
          <div v-if="PAGE.JUZMATCH_CRM.includes(selectedBot.pageid)">
            <div class="caption">ประเภทบัญชี</div>
            <div class="form-control mb-2">
              <multiselect
                v-model="input.juzmatch_member_type"
                :options="juzmatchMemberTypeOption"
                placeholder="ประเภทบัญชี"
                :multiple="false"
                label="text"
                deselect-label
                :taggable="true"
              >
              </multiselect>
            </div>
          </div>
        </template>
        <template v-if="$aston.astonpages.includes($store.state.livechat.pageid)">
          <v-select
            v-model="input.assignadminname"
            :items="computedAstonAdmins"
            outline
            label="Assign to"
            hide-details
            class="mt-4"
            color="primary"
          ></v-select>

          <div class="mt-4">ประเภทลูกค้า</div>
          <v-select
            v-model="input.session"
            :items="$store.state.astonCustomerGroup"
            outline
            label="ประเภทลูกค้า"
            hide-details
            class="mt-1"
            color="primary"
          ></v-select>

          <v-layout class="mt-3">
            <v-flex>
              <div class="form-control">
                <label>Last Conversation From</label>
                <v-layout wrap>
                  <v-flex
                    xs6
                    class="form-control"
                    :class="{ 'has-error': errors.has('startdate') }"
                  >
                    <v-menu
                      ref="openStartDate"
                      v-model="openStartDate"
                      :close-on-content-click="false"
                      full-width
                      max-width="290px"
                      color="primary"
                    >
                      <template #activator="{ on }">
                        <input
                          v-model="input.lastconversationfromdate"
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Date')"
                          readonly
                          clearable
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="input.lastconversationfromdate"
                        color="primary"
                        @input="openStartDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs4 class="pl-1">
                    <v-menu
                      ref="openStartTime"
                      v-model="openStartTime"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="input.lastconversationfromtime"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      :disabled="input.lastconversationfromdate == null"
                      max-width="290px"
                      min-width="290px"
                    >
                      <template #activator="{ on }">
                        <input
                          v-model="input.lastconversationfromtime"
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Time')"
                          readonly
                          :disabled="input.lastconversationfromdate == null"
                          v-on="on"
                        />
                      </template>
                      <v-time-picker
                        v-if="openStartTime"
                        v-model="input.lastconversationfromtime"
                        full-width
                        @click:minute="$refs.openStartTime.save(input.lastconversationfromtime)"
                      ></v-time-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs2>
                    <v-btn
                      fab
                      flat
                      small
                      color="primary"
                      style="height: 35px; width: 35px"
                      @click="
                        input.lastconversationfromdate = null
                        input.lastconversationfromtime = null
                      "
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
            <v-flex>
              <div class="form-control">
                <label>Last Conversation To</label>
                <v-layout wrap>
                  <v-flex
                    xs6
                    class="form-control"
                    :class="{ 'has-error': errors.has('startdate') }"
                  >
                    <v-menu
                      ref="openEndDate"
                      v-model="openEndDate"
                      :close-on-content-click="false"
                      full-width
                      max-width="290px"
                      color="primary"
                    >
                      <template #activator="{ on }">
                        <input
                          v-model="input.lastconversationtodate"
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Date')"
                          readonly
                          clearable
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="input.lastconversationtodate"
                        color="primary"
                        @input="openEndDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs4 class="pl-1">
                    <v-menu
                      ref="openEndTime"
                      v-model="openEndTime"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="input.lastconversationtotime"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                      :disabled="input.lastconversationtodate == null"
                    >
                      <template #activator="{ on }">
                        <input
                          v-model="input.lastconversationtotime"
                          type="text"
                          class="form-control browser-default"
                          :placeholder="$t('Time')"
                          readonly
                          :disabled="input.lastconversationtodate == null"
                          v-on="on"
                        />
                      </template>
                      <v-time-picker
                        v-if="openEndTime"
                        v-model="input.lastconversationtotime"
                        full-width
                        @click:minute="$refs.openEndTime.save(input.lastconversationtotime)"
                      ></v-time-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs2>
                    <v-btn
                      fab
                      flat
                      small
                      color="primary"
                      style="height: 35px; width: 35px"
                      @click="
                        input.lastconversationtodate = null
                        input.lastconversationtotime = null
                      "
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
        </template>
        <template v-if="$store.state.rabbitPage.includes(selectedBot.pageid)">
          <!-- RABBIT PAGE -->
          <!-- <div class="form-control mt-2">
            <div>Name</div>

            <input v-model="input.realname" type="text" />
          </div> -->
          <div class="form-control">
            <div>Card number</div>
            <input v-model="input.cardnumber" type="text" />
          </div>
        </template>
        <div v-if="['102549712095297', '105387828535129'].includes(selectedBot.pageid)">
          <div class="caption mt-2">{{ $t('Chat Status') }}</div>
          <Multiselect
            v-model="input.chatstatus"
            :options="chatstatusOption"
            :show-labels="false"
            :multiple="false"
            :searchable="false"
            :allow-empty="false"
            placeholder="Chat Status"
          ></Multiselect>
        </div>
        <div v-if="selectedBot.type === 'summithr'">
          <div class="caption mt-2">สถานะพนักงาน</div>
          <multiselect
            v-model="input.member_status"
            :options="['active', 'inactive']"
            placeholder="สถานะพนักงาน"
            :multiple="false"
          >
          </multiselect>
        </div>
        <div class="mb-3 mt-2 form-control">
          <div class="caption">{{ $t('Channel') }}</div>
          <v-radio-group v-model="tempApp" row hide-details>
            <v-radio :label="$t('All')" value="all" color="primary"></v-radio>
            <template v-for="channel in livechatChannelOptions">
              <v-radio
                :key="channel.value"
                :label="channel.text"
                :value="channel.fullValue"
                color="primary"
              ></v-radio>
            </template>
          </v-radio-group>
        </div>
        <!--
          v-if="
            ['ustore'].includes(selectedBot.theme) ||
              ['102549712095297'].includes(selectedBot.pageid)
          " -->
        <div class="mb-3 form-control">
          <div class="caption">{{ $t('admin_read_status') }}:</div>
          <v-radio-group v-model="input.adminread" row hide-details>
            <v-radio :label="$t('All')" :value="null" color="primary"></v-radio>
            <v-radio :label="$t('Read')" :value="true" color="primary"></v-radio>
            <v-radio :label="$t('Unread')" :value="false" color="primary"></v-radio>
          </v-radio-group>
        </div>
        <div class="mb-3 form-control">
          <div class="caption">{{ $t('user_read_status') }}:</div>
          <v-radio-group v-model="input.is_user_read_message" row hide-details>
            <v-radio :label="$t('All')" :value="null" color="primary"></v-radio>
            <v-radio :label="$t('Read')" :value="true" color="primary"></v-radio>
            <v-radio :label="$t('Unread')" :value="false" color="primary"></v-radio>
          </v-radio-group>
        </div>
        <div class="mb-3 form-control">
          <div class="caption">{{ $t('Chat type') }}:</div>
          <v-radio-group v-model="input.inbox" row>
            <v-radio :label="$t('All')" value="" color="primary"></v-radio>
            <v-radio :label="$t('Admin')" value="admin" color="primary"></v-radio>
            <v-radio :label="$t('chatbot')" value="bot" color="primary"></v-radio>
          </v-radio-group>
        </div>
        <div class="mb-3 form-control">
          <div class="caption">เวลา</div>
          <date-filter v-model="selectedDate" :fullsize="false" :hide-search="true"></date-filter>
        </div>
        <v-layout>
          <v-flex class="pa-1">
            <v-btn block depressed @click="clearSearch">
              <v-icon>clear</v-icon>
              {{ $t('Clear All') }}
            </v-btn>
          </v-flex>
          <v-flex class="pa-1">
            <v-btn block depressed color="primary" @click="onSearch(false)">
              <v-icon>search</v-icon>
              {{ $t('Search') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import DateFilter from '../dashboard/DateFilter'
import api from '@/api'
import cloneDeep from 'lodash/cloneDeep'
import { PAGE } from '@/constants/page.js'
import LivechatSocialChannel from './LivechatSocialChannelMixin'
export default {
  components: {
    Multiselect,
    DateFilter
  },
  mixins: [LivechatSocialChannel],
  props: {
    // eslint-disable-next-line vue/require-prop-types
    value: {
      default: false
    }
  },
  data() {
    return {
      selectedDate: {
        start: null,
        end: null
      },
      chatstatusOption: ['กำลังดำเนินการ', 'ดำเนินการแล้ว', 'ติดตาม'],
      input: {
        ...this.getSearchTemplate()
      },
      openStartDate: false,
      openEndDate: false,
      openStartTime: false,
      openEndTime: false,
      tagOptions: [],
      statusOptions: [],

      messagesStatusOptions: [
        { text: 'Read', value: true },
        { text: 'Unread', value: false }
      ],
      isClearSearch: false,
      tempApp: 'all',
      juzmatchMemberTypeOption: [
        { text: 'ผู้เช่าซื้อ', value: 'buyer' },
        { text: 'นักลงทุน', value: 'invester' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    selectedUser: {
      get() {
        return this.$store.state.livechat.currentUser
      },
      set(newVal) {
        this.$store.state.livechat.currentUser = newVal
      }
    },
    computedAstonAdmins() {
      if (this.$aston.astonpages.includes(this.$store.state.livechat.pageid)) {
        if (this.astonAdmins) {
          var admins = this.astonAdmins.map((el) => {
            return {
              text: el.name,
              value: el.name
            }
          })
          admins.unshift({ text: 'ยังไม่ได้ Assign', value: '' })
          return admins
        } else {
          return []
        }
      } else {
        return []
      }
    },
    PAGE() {
      return PAGE
    }
  },
  watch: {
    async value(newVal) {
      if (newVal) {
        await this.loadStatusAndTag()
      }
    }
  },
  async mounted() {},

  methods: {
    getSearchTemplate() {
      return {
        uuAreaName: '',
        search: '',
        uu_register_status: '',
        lastconversationfromdate: null,
        lastconversationtodate: null,
        lastconversationfromtime: null,
        lastconversationtotime: null,
        lastconversationfrom: null,
        lastconversationto: null,
        phoneno: null,
        uu_name: null,
        keyword: '',
        tags: [],
        status: null,
        app: '',
        session: '',
        assignadminname: '',
        realname: '',
        cardnumber: '',
        chatstatus: '',
        adminread: null,
        is_user_read_message: null,
        email: '',
        inbox: '',
        customrealname: '',
        member_status: '',
        juzmatch_member_type: '',
        address: '',
        note: '',
        employee_id: '',
        position: '',
        department: ''
      }
    },
    async loadStatusAndTag() {
      this.getUserTagList()
      this.getUserStatusList()
    },
    async getUserTagList() {
      var response = await api.getUserTagList()
      if (response && response.result) {
        this.tagOptions = response.result.map((item) => {
          return item.name
        })
      }
    },
    async getUserStatusList() {
      var response = await api.getUserStatusList()
      if (response && response.result) {
        this.statusOptions = response.result.map((item) => {
          return item.name
        })
      }
    },
    clearSearch() {
      this.isClearSearch = true
      this.selectedDate = {
        end: null,
        start: null
      }
      this.input = {
        ...this.getSearchTemplate()
      }
      this.tempApp = 'all'
      if (this.$aston.astonpages.includes(this.$store.state.livechat.pageid)) {
        this.input.session = ''
        this.input.assignadminname = ''
      }
      this.onSearch(true)
    },
    onSearch(isclear = false) {
      let vm = this
      if (vm.input.lastconversationfromdate) {
        vm.input['lastconversationfrom'] =
          vm.input.lastconversationfromdate +
          (vm.input.lastconversationfromtime ? ' ' + vm.input.lastconversationfromtime : ' 00:00')
      } else {
        vm.input['lastconversationfrom'] = null
      }
      if (vm.selectedDate.start && vm.selectedDate.end) {
        vm.input.datefrom = vm.selectedDate.start
        vm.input.dateto = vm.selectedDate.end
      }
      if (vm.input.lastconversationtodate) {
        vm.input['lastconversationto'] =
          vm.input.lastconversationtodate +
          (vm.input.lastconversationtotime ? ' ' + vm.input.lastconversationtotime : ' 23:59')
      } else {
        vm.input['lastconversationto'] = null
      }

      if (vm.isClearSearch && vm.tempApp === 'all') {
        vm.input.app = ''
      } else {
        vm.input.app = vm.tempApp
      }

      if (this.$aston.astonpages.includes(this.$store.state.livechat.pageid)) {
        this.input.adminname = this.input.assignadminname
      }

      if (!isclear) {
        vm.input.is_search = true
      }

      let tempInput = cloneDeep(vm.input)
      tempInput.juzmatch_member_type =
        tempInput.juzmatch_member_type && tempInput.juzmatch_member_type.value
          ? tempInput.juzmatch_member_type.value
          : ''
      vm.$store.commit('SET_LIVECHAT_FILTER', tempInput)

      vm.usersearching = true
      vm.$nextTick(() => {
        vm.$store.dispatch('forceLoadLastestUsers').then(() => {
          vm.usersearching = false
        })
        vm.$emit('input', false)
      })
      vm.isClearSearch = false
    },
    addStatus(newStatus) {
      const status = newStatus
      this.statusOptions.push(status)
      this.input.status = status
    },
    addTag(newTag) {
      const tag = newTag
      // this.tagOptions.push(tag)
      this.input.tags.push(tag)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/LivechatSearch.vue